import { render, staticRenderFns } from "./max-number.vue?vue&type=template&id=01d49337&"
import script from "./max-number.vue?vue&type=script&lang=ts&"
export * from "./max-number.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports